import React from 'react';
import { Skeleton, useMediaQuery } from '@mui/material';
import { CollectionsOutlined, DescriptionOutlined, ViewCarouselOutlined } from '@mui/icons-material';
import StudioSectionHeading from './StudioSectionHeading';

export function StudioArtworkImageShell({ label = 'Loading scene image' }: { label?: string }) {
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  return <span className="studio-artwork-image-shell" role="status" aria-label={label}>
    <Skeleton aria-hidden="true" variant="rounded" animation={reducedMotion ? false : 'pulse'} width="100%" height="100%" />
  </span>;
}

/** Hold the two storyboard cards in place until their content arrives. */
export default function StudioArtworkLoading({ showHeading = true }: { showHeading?: boolean }) {
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const animation = reducedMotion ? false : 'pulse';
  return <div className="studio-preview-stack" aria-busy="true" aria-label="Loading storyboard">
    {showHeading && <StudioSectionHeading primary title="Storyboard" icon={<ViewCarouselOutlined />} />}
    <div className="studio-artwork-assets">
      <section className="studio-document studio-artwork-section" aria-label="Scene plan loading">
        <div className="studio-artwork-loading-heading"><DescriptionOutlined aria-hidden="true" /><h3>Scene plan</h3></div>
        <div className="studio-scene-plan-peek" aria-hidden="true">
          {[76, 62, 84].map((width, index) => <div className="studio-scene-plan-peek-row" key={index}>
            <Skeleton variant="text" animation={animation} width={20} height={22} />
            <Skeleton variant="text" animation={animation} width={`${width}%`} height={22} />
          </div>)}
          <div className="studio-scene-plan-peek-more"><Skeleton variant="text" animation={animation} width={100} height={22} /></div>
        </div>
      </section>
      <section className="studio-document studio-artwork-section studio-canvas-storyboard-images" aria-label="Storyboard images loading">
        <div className="studio-artwork-loading-heading"><CollectionsOutlined aria-hidden="true" /><h3>Storyboard images</h3></div>
        <div className="studio-artwork-loading-images" aria-hidden="true">
          {Array.from({ length: 6 }, (_, index) => <div className="studio-artwork-thumbnail" key={index}><StudioArtworkImageShell /></div>)}
        </div>
      </section>
    </div>
  </div>;
}
